import styled from "@emotion/styled";
import { Grid } from "@mui/material";


const MobBg = styled.div`
  @media screen and (max-width:799px){
background-size: contain;
background-repeat: no-repeat;
background-position: TOP left;
  }
`;

const VideoBG = styled.video`
 object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;

`
const Wrapper = styled.div`
min-height:100vh;
`
const WrapperSec = styled.div`
 position: relative;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  @media screen and (max-width:799px){
    position: relative;
  }
`
const Shadow = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  max-width: 500px;
  @media screen and (max-width:799px){
  display: none;
  }
`
const PageWrapper = styled.div`
 /* position: relative; */
  background-color: ${(props) => props.theme.pageColor};
`;
const Heading = styled.h1`
font-family: "P-SM";
  font-size: ${(props) => (props.fs ? props.fs : "22px")};
  
  color: ${(props) =>
    props.color ? props.color : "#000000"};
  overflow-wrap: ${(props) => (props.ow ? props.ow : "")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "0")};

  @media (max-width: 1100px) {
    font-size: ${(props) => (props.fs1100 ? props.fs1100 : "14px")};
    max-width: 100%;
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.pt630 ? props.pt630 : "")};
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
  }
`;

const CardDiv = styled.div`
  /* background-color: #141212; */
  /* padding: 30px; */
  border-radius: 10px;
`;

const ContentDiv = styled.div`
  display: inline-flex;
  padding: 30px 0;
  padding-top: 0;
  gap: 20px;
  @media (max-width: 768px) {
    /* display: block; */
  }
`;

const GridTextCentered = styled(Grid)`
  display: flex;
  text-align: right;
  justify-content: end;
  align-items: center;
`;

const ParaDiv = styled.div`
  max-width: 500px;
  /* padding: 30px; */
  @media (max-width: 768px) {
    padding: 22px 0;
  }
`;

const Btn = styled.button`
  cursor: pointer;
  border-radius: 40px;
  border: 1px solid #fff;
  font-weight: bolder;
  color: #fff;
  background-color: transparent;
  padding: 10px;
  padding-left: 40px;
  padding-right: 40px;
  @media (max-width: 768px) {
    margin: 10px;
  }
`;

const BlueBtn = styled.button`
  text-decoration: none;
  border-radius: 40px;
  cursor: pointer;
  color: #48BA7F;
  background-color: #fff;
  padding: 10px 40px;
  font-weight: bolder;
  display: flex;
  font-size: 15px;
  align-items: center;
  border: none;
  @media (max-width: 768px) {
    margin: 10px 0;
  }
`;
const BlueBtnComm = styled.button`
  text-decoration: none !important;
  display: flex;
  align-items: center;
  font-size: 15px;
  border-radius: 40px;
  cursor: pointer;
  color: #fff;
background: linear-gradient(270deg, rgba(41,142,90,1) 0%, rgba(72,186,127,1) 50%, rgba(41,142,90,1) 100%);
  padding: 10px 40px 10px 40px;
  align-items: center;
  border: none;
  @media (max-width: 768px) {
    /* padding: 10px; */
  }
`;

const RedBtn = styled.button`
  cursor: pointer;
  border-radius: 40px;
  color: #fff;
  background-color: #ff5555;
  padding: 10px 40px 5px 40px;
  border: none;
  @media (max-width: 768px) {
    margin: 10px;
  }
`;

const MainDiv = styled.div`
  padding: 75px 0;
  background-color:#E6BD23;
`;

const GridCenterAligned = styled(Grid)`
  justify-content: center;
  padding: 20px 0;
  text-align: center;
  align-items: center;
  
`;

const ImageDiv = styled.div`
  padding: 15px;
  padding-left: 0;
`;
const GridCentered = styled(Grid)`
  /* text-align: center; */
  justify-content: center;
  align-items: center;
`;
const SectionWrapper = styled.div`
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : "#000000"};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};

  }
`;
const HeaderWrapper = styled.div`
/* min-height: 100vh; */
min-height: calc(100vh - 81px);
display: flex;
    align-items: flex-end;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "")};
 
  /* padding: 20px 0px; */
  @media screen and (max-width: 1199px) {
    /* min-height: 88vh; */
  }
  @media screen and (max-width: 899px) {
    
  padding: ${(props) => (props.p899 ? props.p899 : "0 20px")};
    display: contents;
  }
`;
const P = styled.p`
  font-family: "P-R";
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: ${(props) => (props.color ? props.color : "#000")};
  
  overflow-wrap: ${(props) => (props.ow ? props.ow : "")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};

  @media (max-width: 1100px) {
    font-size: 14px;
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const SectionHeading = styled.h2`
  text-align: ${(props) => (props.align ? props.align : "left")};
  color: ${(props) => (props.color ? props.color : "#000")};
  
  font-size: ${(props) => (props.fs ? props.fs : "100px")};
  font-family: "Matur";
  padding: ${(props) => (props.p ? props.p : "0")};
  line-height: 70px;
  margin: ${(props) => (props.m ? props.m : "0")};
  @media (max-width: 1399px) {
    font-size: ${(props) => (props.fs1399 ? props.fs1399 : "")};
  }
  @media (max-width: 899px) {
    font-size: 50px;
  }
  @media (max-width: 599px) {
    padding: ${(props) => (props.P599 ? props.p599 : "0px 0")};
    line-height: unset;
  font-size: ${(props) => (props.fs599 ? props.fs599 : " 40px")};
  }
  `;
const SectionSubHeading = styled.h3`
background-color: ${(props) => (props.color ? props.color : "#000")};
color: ${(props) => (props.color ? props.color : "#fff")};
  font-family: "P-M";
  font-size: ${(props) => (props.fs ? props.fs : "35px")};
  padding: ${(props) => (props.p ? props.p : "0 10PX")};
  margin: ${(props) => (props.m ? props.m : "20PX 0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  width: ${(props) => (props.mw ? props.mw : "18%")};
  text-align: ${(props) => (props.align ? props.align : "")};
  
  @media (max-width: 1299px) {
    width: ${(props) => (props.mw ? props.mw : "28%")};
  }
  @media (max-width: 599px) {
    width: ${(props) => (props.mw ? props.mw : "38%")};
    /* width: ${(props) => (props.mw ? props.mw : "18%")}; */
    padding: ${(props) => (props.p599 ? props.p599 : "")};
    line-height: ${(props) => (props.lh ? props.lh : "")};
    font-size: ${(props) => (props.fs599 ? props.fs599 : "30px")};
  }
`;
const SectionColordHeading = styled.span`
color: ${(props) => (props.color ? props.color : "#E09427")};
  font-family: "Poppins-Medium";
  font-size: ${(props) => (props.fs ? props.fs : "40px")};
  /* text-transform: ${(props) => (props.tt ? props.tt : "uppercase")}; */
  padding: 0;
  text-align: ${(props) => (props.align ? props.align : "")};
  margin: ${(props) => (props.m ? props.m : "0")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "")};

  @media (max-width: 599px) {
    line-height: ${(props) => (props.lh ? props.lh : "")};
    max-width: 100%;
    font-size: ${(props) => (props.fs599 ? props.fs599 : "30px")};
  }
`;
const SectionSmallHeading = styled.h3`
  font-family: "P-M";
  font-size: ${(props) => (props.fs ? props.fs : "20px")};
  text-transform: ${(props) => (props.tt ? props.tt : "")};
  color: ${(props) => (props.color ? props.color : "#fff")};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};

  @media (max-width: 599px) {
    line-height: ${(props) => (props.lh ? props.lh : "")};
    max-width: 100%;
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
  }
`;

export { SectionWrapper, P, SectionHeading, SectionSubHeading, SectionSmallHeading, SectionColordHeading, Heading, CardDiv, GridCenterAligned, MainDiv, ContentDiv, GridTextCentered, ParaDiv, BlueBtn, Btn, ImageDiv, GridCentered, RedBtn, BlueBtnComm, PageWrapper, HeaderWrapper, MobBg, VideoBG, Wrapper, WrapperSec, Shadow, };
